import { useCallback, useEffect } from "react";
import { useLeadContext } from "@contexts";
import { GetChannels, GetBrands, GetAprs, GetInstallmentPlans, GetProductType, GetAgents } from "../services/lead";

const useGetLeadsBasicData = () => {
    const { setChannels, setAgents, setBrands, setInstallmentPlans, setProductType, setAprs } = useLeadContext();

    const fetchAgents = useCallback(async () => {
            const agentData = await GetAgents();
            setAgents(agentData);
        }, []);

    const fetchChannels = useCallback(async () => {
        const channelData = await GetChannels();
        setChannels(channelData);
    }, [setChannels]);

    const fetchBrands = useCallback(async () => {
        const response = await GetBrands();
        setBrands(response);
    }, [setBrands]);

    const fetchApr = useCallback(async () => {
        const response = await GetAprs();
        setAprs(response);
    }, [setAprs]);

    const fetchInstallmentPlans = useCallback(async () => {
        const response = await GetInstallmentPlans();
        setInstallmentPlans(response);
    }, [setInstallmentPlans]);

    const fetchProductTypes = useCallback(async () => {
        const response = await GetProductType();
        setProductType(response);
    }, [setProductType]);

    useEffect(() => {
        fetchBrands();
        fetchAgents();
        fetchChannels();
        fetchInstallmentPlans();
        fetchProductTypes();
        fetchApr();
    }, [fetchChannels, fetchBrands, fetchInstallmentPlans, fetchProductTypes, fetchApr]);
};

export default useGetLeadsBasicData;